import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { MinLoader } from 'components';
import { ScheduleDetails } from 'fragments';
import { notificationTypesEnums, renderIcon } from '../../../../fragments/notification/constants';
import { Colors, FindLoad, FindSuccessItem, Images, PermissionList, RolePermission, useSecondaryModal } from 'utils';
import { httpRequestsOnSuccessActions, notificationActions } from 'store';

const MARK_SINGLE = 'MARK_SINGLE_AS_READ';
const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

export const NotificationsAlertsCard = ({ info, getNotifications }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState(null);
    const loadDelete = FindLoad(DELETE_NOTIFICATION);
    const loadMarkSingle = FindLoad(MARK_SINGLE);
    const markSingle = FindSuccessItem(MARK_SINGLE);
    const deleteNote = FindSuccessItem(DELETE_NOTIFICATION);
    const { openSecondary } = useSecondaryModal();

    useEffect(() => {
        if (markSingle) {
            setSelectedId(null);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(MARK_SINGLE));
            getNotifications('noLoad');
        }

        if (deleteNote) {
            setSelectedId(null);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_NOTIFICATION));
            getNotifications('noLoad');
        }
    }, [markSingle, deleteNote]);

    const handleMarkAsRead = (item) => {
        if (!item?.isRead) {
            setSelectedId(item?.id);
            dispatch(notificationActions.markSingleAsRead(item?.id));
        }

        if (
            (item?.notificationType === notificationTypesEnums.APPT_CREATE ||
                item?.notificationType === notificationTypesEnums.APPT_UPDATE ||
                item?.notificationType === notificationTypesEnums.APPT_CANCEL ||
                item?.notificationType === notificationTypesEnums.APPT_LOCK ||
                item?.notificationType === notificationTypesEnums.APPT_UNLOCK ||
                item?.notificationType === notificationTypesEnums.APPT_RENDER ||
                item?.notificationType === notificationTypesEnums.APPT_UNRENDER ||
                item?.notificationType === notificationTypesEnums.APPT_ADD_NOTE_REQUEST ||
                item?.notificationType === notificationTypesEnums.APPT_UPDATE_NOTE_REQUEST ||
                item?.notificationType === notificationTypesEnums.APPT_ADD_NOTE_RESOLVED) &&
            item?.resourceId
        ) {
            const defaultTab =
                item?.notificationType === notificationTypesEnums.APPT_ADD_NOTE_REQUEST ||
                item?.notificationType === notificationTypesEnums.APPT_UPDATE_NOTE_REQUEST ||
                item?.notificationType === notificationTypesEnums.APPT_ADD_NOTE_RESOLVED;
            openSecondary(<ScheduleDetails currentId={item?.resourceId} defaultTab={defaultTab ? 'Notes' : ''} />);
        }
        if (
            (item?.notificationType === notificationTypesEnums.LICENSE_EXPIRATION ||
                item?.notificationType === notificationTypesEnums.CREDENTIALS_EXPIRATION) &&
            RolePermission([PermissionList.STAFF_READ.code])
        ) {
            navigate(`/staff/${info?.id}`);
        }
        if (
            (item?.notificationType === notificationTypesEnums.SERVICE_ADD ||
                item?.notificationType === notificationTypesEnums.SERVICE_DELETE) &&
            RolePermission([PermissionList.STAFF_SERVICE_MANAGE?.code, PermissionList.STAFF_SERVICE_READ?.code])
        ) {
            navigate(`/staff/${info?.id}`, {
                state: { activeTab: 'Services' },
            });
        }
    };

    const deleteNotification = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedId(item?.id);
        dispatch(notificationActions.deleteNotification(item?.id));
    };

    const renderDuration = (time) => {
        const diff = moment().diff(moment(time));
        const duration = moment.duration(diff);
        const totalDays = Math.floor(duration.asDays());
        const totalHours = Math.floor(duration.asHours());
        const totalMinutes = Math.floor(duration.asMinutes());

        if (totalDays > 0) return `${totalDays} day(s) ago`;
        if (totalHours > 0) return `${totalHours} hour(s) ago`;
        if (totalMinutes > 0) return `${totalMinutes} min(s) ago`;
        return 'Just now';
    };

    return (
        <div className="dashboard-notifications-block" onClick={() => handleMarkAsRead(info)}>
            <div className="dashboard-notifications-icon-block">
                <img src={renderIcon(info?.notificationType)} alt="icon" />
            </div>

            <div className="dashboard-notifications-title-body">
                <div className="dashboard-notifications-title-box">
                    {info?.title && <p className="dashboard-notifications-title">{info?.title}</p>}
                    <div className="dashboard-notifications-meta">
                        {renderDuration(info?.notifiedAt) && (
                            <p className="dashboard-notifications-notifiedAt-text">{renderDuration(info?.notifiedAt)}</p>
                        )}
                        {!info?.isRead && (
                            <span className="dashboard-notifications-status">
                                {selectedId === info?.id && loadMarkSingle?.length ? (
                                    <MinLoader position={'relative'} color={Colors.ThemeBlue} margin={'0'} width={'14px'} height={'14px'} />
                                ) : (
                                    <span className="dashboard-notifications-new-dot" />
                                )}
                            </span>
                        )}
                    </div>
                </div>
                {info?.body && <p className="dashboard-notifications-sub-title">{info?.body}</p>}
            </div>

            {info?.isRead && (
                <button onClick={(e) => deleteNotification(e, info)} className="dashboard-notifications-delete-box">
                    {selectedId === info?.id && loadDelete?.length ? (
                        <MinLoader position={'relative'} color={Colors.ThemeRed} margin={'0'} small={true} />
                    ) : (
                        <img src={Images.remove} alt="remove" />
                    )}
                </button>
            )}
        </div>
    );
};
